export default __webpack_public_path__ + "assets/images/Dashboard-c8533a6b51e5af788f06849aec2c9d74.svg";